'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _ModalPortal = require('./ModalPortal');

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ModalBackground = require('./ModalBackground');

var _ModalBackground2 = _interopRequireDefault(_ModalBackground);

var _ModalContainer = require('./ModalContainer');

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

var _ModalDialog = require('./ModalDialog');

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

exports['default'] = {
  ModalPortal: _ModalPortal2['default'],
  ModalBackground: _ModalBackground2['default'],
  ModalContainer: _ModalContainer2['default'],
  ModalDialog: _ModalDialog2['default']
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-modal-dialog/lib/index.js
 ** module id = 1055
 ** module chunks = 0
 **/